import { Grid, Dialog, DialogTitle, DialogContent, Button } from '@material-ui/core'
import React, { useState } from 'react'
import { ValidatorForm } from 'react-material-ui-form-validator'
import { useDispatch } from 'react-redux';
import Buscador from '../../../actions/ui/Buscador';
import { ListaAfiliadosRecupero } from './ListaAfiliadosRecupero';
import { getDatosAfiliadosRecupero } from '../../../actions/autorizaciones/Autorizaciones';
import { AltaAfiliadoRecupero } from './AltaAfiliadoRecupero';

export const AfiliadosRecuperoHome = () => {

    const dispatch = useDispatch();
    const tipoBusqueda = "Todos";
    const altaBaja = "Todos";
    const [open, setOpen] = useState(true);
    const [openModificacion, setOpenModificacion] = useState(false);
    const [openAltaRecupero, setOpenAltaRecupero] = useState(false);
    const [value, setValue] = useState(null);

    const onSubmitHandler = () => {
        dispatch(getDatosAfiliadosRecupero(
            value?.id_afiliado,
        ))
        setOpenModificacion(true)
        setOpen(false);
    }

    const onClose = () => {
        setOpen(false);
    };

    return (
        <React.Fragment>
            {openModificacion && (
                <ListaAfiliadosRecupero
                    open={openModificacion}
                    close={() => {
                        setOpenModificacion(false);
                    }}
                />
            )}
            {openAltaRecupero && (
                <AltaAfiliadoRecupero
                    open={openAltaRecupero}
                    close={() => {
                        setOpenAltaRecupero(false);
                    }}
                />
            )}
            <Dialog fullWidth maxWidth="md" open={open} >
                <DialogTitle>
                    <span style={{ float: 'left', paddingLeft: 15 }}>Buscar Afiliado</span>
                    <Grid item xs={12} md={12} style={{ paddingLeft: 0, marginTop: 20 }}>
                        <div
                            style={{
                                margin: '1rem 0',
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'flex-end',
                            }}
                        >
                            <Button variant="contained" color="primary" onClick={() => setOpenAltaRecupero(true)}>
                                Alta Afiliado Recupero
                            </Button>
                        </div>
                    </Grid>
                </DialogTitle>
                <DialogContent>

                    <ValidatorForm onSubmit={onSubmitHandler}>
                        <Grid container spacing={2}>
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                lg={12}
                                style={{ alignSelf: 'center', paddingLeft: 16 }}
                            >

                                <Buscador
                                    value={value}
                                    variant="outlined"
                                    setValue={(val) => { setValue(val) }}
                                    label="Apellido y Nombre  |  CUIT  |  DNI  |  Numero Beneficiaria/o"
                                    noOptionText={"No se encuentra beneficiaria/o"}
                                    endpoint={(texto) =>
                                        `Afiliados/traerPorNombreoDNIoNroAfi/${texto}/${tipoBusqueda}/${altaBaja}`
                                    }
                                    getOptionLabel={(option) =>
                                        `${option.apellido_y_nombre} ${option.carnet} ${option.cuil} ${option.nro_doc}`
                                    }
                                    renderOption={(option) => (
                                        <div style={{ display: "flex", flexDirection: "column" }}>
                                            <span
                                                style={
                                                    option.fecha_baja === null
                                                        ? { color: "green" }
                                                        : { color: "red" }
                                                }
                                            >
                                                {`${option.apellido_y_nombre}`}
                                            </span>
                                            <span
                                                style={{
                                                    fontSize: 12,
                                                }}
                                            >
                                                {" "}
                                                {`Nro Afi:${option.carnet} - CUIL:${option.cuil}`}
                                            </span>
                                        </div>
                                    )}
                                />
                            </Grid>
                        </Grid>
                        <div
                            style={{
                                marginTop: "2rem",
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-evenly',
                            }}
                        >
                            <Button variant="contained" color="primary" onClick={onClose}>
                                Cancelar
                            </Button>
                            <Button
                                type="submit"
                                variant="contained"
                                //disabled={props.disabled}
                                color="primary"
                            >
                                Buscar
                            </Button>
                        </div>
                    </ValidatorForm>
                </DialogContent>
            </Dialog>
        </React.Fragment>
    )
}
